import { SetOwner } from '@adaptiva/core/common';
import { provideBaseWidget } from '@adaptiva/core/widgets';
import { BaseEditorError, EEditorErrorType, IBaseEditorError } from '@adaptiva/data-service';
import { InputComponent } from '@adaptiva/widgets/input';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { BaseScheduleTypeComponent } from '../base-schedule-type.component';

@Component({
	standalone: false,
	selector: 'app-recurring-by-last-day',
	templateUrl: './recurring-by-last-day.component.html',
	providers: [provideBaseWidget(() => RecurringByLastDayComponent)],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecurringByLastDayComponent extends BaseScheduleTypeComponent {

	@ViewChild('RecurringIntervalInMonthsInput')
	@SetOwner recurringIntervalInMonthsInput: InputComponent;

	public numberOfMonths = 1;

	public validate(): IBaseEditorError[] {
		const _errors: IBaseEditorError[] = [];

		if (this.numberOfMonths < 1) {
			_errors.push(
				new BaseEditorError(
					EEditorErrorType.Error,
					this.guid,
					['RecurringIntervalInMonthsInput', 'Number of months must be greater than 0']
				)
			);
		}

		return _errors;
	}

	public commitModelToView(): void {
		if (this.schedule)
			this.numberOfMonths = this.schedule.numberOfMonths;
	}

	// event listeners start
	setNumberOfMonths(event: string) {
		const months = +event;

		if (months !== this.numberOfMonths) {
			this.numberOfMonths = months;
			this.outputChanges([
				{ propertyName: 'numberOfMonths', value: this.numberOfMonths }
			]);
		}
	}
	// event listeners end

}
